(function() {
  const wrapper  = document.querySelector('.inline-search-wrapper');
  const toggle   = document.querySelector('.inline-search__toggle');
  const closeBtn = document.querySelector('.inline-search__close');
  const input    = document.querySelector('.inline-search__input');
  const form     = document.querySelector('.inline-search__form');

  // ── Move results to <body> to escape any parent overflow:hidden ──
  let results = document.querySelector('.inline-search__results');
  if (results) {
    document.body.appendChild(results);
  } else {
    results = document.createElement('div');
    results.className = 'inline-search__results';
    results.setAttribute('role', 'listbox');
    results.setAttribute('aria-label', 'Search suggestions');
    document.body.appendChild(results);
  }

  let debounceTimer = null;

  function positionResults() {
  var formRect = form.getBoundingClientRect();
  var top = formRect.bottom + 2;
  results.style.position = 'fixed';
  results.style.top      = top + 'px';
  results.style.left     = formRect.left + 'px';
  results.style.width    = formRect.width + 'px';
  // Above the Shopify chat bubble, which plants itself in the
  // bottom-right corner at 2147483000 — higher than anything the theme
  // sets, and immune to being hidden by a rule of ours (it forces its
  // own display from its own stylesheet). That didn't matter while this
  // was a short list of six that never reached the corner; now that it
  // can fill the screen, the bubble would otherwise sit on top of a
  // result and take the tap meant for it. Layering the panel over it,
  // rather than hiding it, also leaves the bubble reachable as normal
  // whenever the list is short enough not to reach that far down.
  results.style.zIndex   = '2147483001';
  // Now that the list can run to every matching product rather than a
  // fixed few, how tall it is allowed to grow has to come from the
  // screen rather than a fixed number, or a long list simply runs off
  // the bottom with its last results unreachable.
  //
  // visualViewport, where it exists, is the part of the page actually
  // on screen — on a phone that means the space left above the on-screen
  // keyboard, which is exactly the space this list has to live in while
  // someone is typing into it. window.innerHeight doesn't shrink for the
  // keyboard on Android, so on its own it would size the list to run
  // underneath one.
  var viewportHeight = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
  results.style.maxHeight = Math.max(160, viewportHeight - top - 12) + 'px';
}

  // ── Result paging state ──────────────────────────────────────────
  // The dropdown shows every product the search matches, not a fixed
  // handful, so it loads them the way the results page does: twenty at
  // a time, with the next twenty fetched as the shopper scrolls near
  // the bottom of the list. Everything about "which search are we
  // showing, and how far into it are we" lives in these four, so a new
  // keystroke can reset all of it in one place.
  var activeQuery = '';
  var loadedPages = 0;
  var totalPages = 0;
  var isLoading = false;
  // Typing again while a fetch is still in the air used to leave the
  // slower, older search to land last and overwrite the newer one.
  // Aborting it outright means only the search the shopper is actually
  // waiting on can ever fill the dropdown.
  var inFlight = null;

  // One place for showing and hiding the dropdown, called from all the
  // several points that need to, rather than each toggling the class
  // itself.
  function showResults(on) {
    results.classList.toggle('is-visible', on);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderProducts(products) {
    var fragment = document.createDocumentFragment();
    products.forEach(function(product) {
      var item = document.createElement('a');
      item.href = product.url;
      item.className = 'inline-search__result-item';
      item.setAttribute('role', 'option');
      var title = escapeHtml(product.title);
      item.innerHTML =
        (product.image
          ? '<img class="inline-search__result-img" src="' + escapeHtml(product.image) + '" alt="' + title + '" loading="lazy" decoding="async" width="48" height="48">'
          : '<div class="inline-search__result-img"></div>') +
        '<div>' +
          '<div class="inline-search__result-title">' + title + '</div>' +
          (product.price ? '<div class="inline-search__result-price">' + escapeHtml(product.price) + '</div>' : '') +
        '</div>';
      fragment.appendChild(item);
    });
    results.appendChild(fragment);
  }

  function setLoadingRow(on) {
    var existing = results.querySelector('.inline-search__loading');
    if (on && !existing) {
      var row = document.createElement('p');
      row.className = 'inline-search__loading';
      row.textContent = 'Loading more…';
      results.appendChild(row);
    } else if (!on && existing) {
      existing.remove();
    }
  }

  /**
   * Fetches one page of results for `query`. The alternate search
   * template behind this (templates/search.suggest.liquid) runs the
   * ordinary product search, so what the dropdown lists and what
   * pressing Enter lists are the same search, in the same order —
   * which the old predictive-search endpoint, capped at ten guesses,
   * could never be.
   */
  function loadPage(query, page) {
    if (isLoading) return;
    isLoading = true;
    if (page > 1) setLoadingRow(true);
    if (inFlight) inFlight.abort();
    var controller = ('AbortController' in window) ? new AbortController() : null;
    inFlight = controller;

    var url = '/search?q=' + encodeURIComponent(query) +
      '&type=product&view=suggest&page=' + page;

    fetch(url, controller ? { signal: controller.signal } : undefined)
      .then(function(res) { return res.json(); })
      .then(function(data) {
        // A response for a search the shopper has already typed past.
        if (query !== activeQuery) return;
        isLoading = false;
        inFlight = null;
        setLoadingRow(false);
        loadedPages = data.page || page;
        totalPages = data.pages || 1;

        var products = data.products || [];
        if (page === 1) {
          results.innerHTML = '';
          results.scrollTop = 0;
          if (products.length === 0) {
            results.innerHTML = '<p class="inline-search__no-results">No products found</p>';
            positionResults();
            showResults(true);
            return;
          }
        }
        renderProducts(products);
        positionResults();
        showResults(true);
        // A short first page on a tall screen can leave nothing to
        // scroll, and then the scroll handler below never gets a chance
        // to ask for page two. Checking straight after rendering fills
        // the dropdown until it actually overflows.
        maybeLoadMore();
      })
      .catch(function(error) {
        isLoading = false;
        setLoadingRow(false);
        // An abort is this script's own doing — a newer keystroke — not
        // a failure, and the newer search is already on its way, so the
        // dropdown is left exactly as it is.
        if (error && error.name === 'AbortError') return;
        inFlight = null;
        showResults(false);
      });
  }

  function maybeLoadMore() {
    if (isLoading || !activeQuery) return;
    if (loadedPages === 0 || loadedPages >= totalPages) return;
    if (results.scrollTop + results.clientHeight >= results.scrollHeight - 240) {
      loadPage(activeQuery, loadedPages + 1);
    }
  }

  results.addEventListener('scroll', maybeLoadMore, { passive: true });

  function fetchResults(query) {
    activeQuery = query;
    loadedPages = 0;
    totalPages = 0;
    isLoading = false;
    if (inFlight) { inFlight.abort(); inFlight = null; }
    if (!query || query.length < 2) {
      showResults(false);
      results.innerHTML = '';
      return;
    }
    loadPage(query, 1);
  }

  input.addEventListener('input', function() {
    clearTimeout(debounceTimer);
    var q = this.value.trim();
    debounceTimer = setTimeout(function() { fetchResults(q); }, 300);
  });

  toggle.addEventListener('click', function() {
    wrapper.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    setTimeout(function() { input.focus(); }, 400);
  });

  function closeSearch() {
    wrapper.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    input.value = '';
    showResults(false);
    results.innerHTML = '';
    // Closing has to clear the paging state too, or reopening the search
    // would carry the previous search's "we're on page 2 of 3" over to a
    // dropdown that is now empty.
    clearTimeout(debounceTimer);
    activeQuery = '';
    loadedPages = 0;
    totalPages = 0;
    isLoading = false;
    if (inFlight) { inFlight.abort(); inFlight = null; }
  }

  closeBtn.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeSearch(); });
  document.addEventListener('click', function(e) {
    if (!wrapper.contains(e.target) && !results.contains(e.target)) {
      showResults(false);
    }
  });

  window.addEventListener('scroll', function() {
    if (results.classList.contains('is-visible')) positionResults();
  }, { passive: true });

  window.addEventListener('resize', function() {
    if (results.classList.contains('is-visible')) positionResults();
  });

  // The on-screen keyboard opening, closing or resizing on a phone is not
  // a window resize and fires nothing above — but it is the single
  // biggest change to how much room this list has, so it has to be
  // listened for separately or the list stays sized for a screen that is
  // now half covered.
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', function() {
      if (results.classList.contains('is-visible')) positionResults();
    });
  }

  function observeDrawer() {
    var drawer = document.querySelector(
      'details[id*="menu"], details[id*="drawer"], details[id*="nav"], .menu-drawer, .header__menu-toggle'
    );
    if (!drawer) return;
    var observer = new MutationObserver(function() {
      var isOpen = drawer.hasAttribute('open') ||
        document.body.classList.contains('overflow-hidden') ||
        document.documentElement.classList.contains('menu-open');
      document.body.classList.toggle('drawer-open', isOpen);
    });
    observer.observe(drawer, { attributes: true, childList: true, subtree: true });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDrawer);
  } else {
    observeDrawer();
  }
})();
